import { stats } from "@/mocks/site";
import { dramaCategories } from "@/mocks/dramas";

type HeroSectionProps = {
  onPickCategory: (category: string) => void;
};

const entryCats = dramaCategories.filter((c) => c !== "全部");

export default function HeroSection({ onPickCategory }: HeroSectionProps) {
  return (
    <section id="top" className="relative w-full overflow-hidden border-b border-background-200 bg-background-50">
      <div className="rules-bg pointer-events-none absolute inset-0 opacity-60" aria-hidden="true" />
      <div className="pointer-events-none absolute -right-16 -top-24 h-80 w-80 overflow-hidden rounded-full opacity-30 md:h-[420px] md:w-[420px]" aria-hidden="true">
        <img
          src="https://readdy.ai/api/search-image?query=abstract%20soft%20warm%20gradient%20texture%20in%20terracotta%20amber%20and%20cream%2C%20blurred%20organic%20shapes%2C%20gentle%20light%2C%20minimal%20artistic%20backdrop%2C%20no%20text&width=900&height=900&seq=hero-deco-01&orientation=squarish"
          alt=""
          className="deco-veil h-full w-full object-cover"
        />
      </div>

      <div className="relative z-10 mx-auto w-full max-w-[1240px] px-4 pb-12 pt-12 md:px-8 md:pb-16 md:pt-20">
        <div className="max-w-3xl">
          <span className="inline-flex items-center gap-2 rounded-full border border-primary-200 bg-primary-50 px-3 py-1 text-xs font-medium text-primary-700">
            <span className="flex h-3.5 w-3.5 items-center justify-center">
              <i className="ri-live-line text-sm" aria-hidden="true" />
            </span>
            真人剧情演绎 · 每日更新
          </span>

          <h1 className="mt-5 font-heading text-3xl font-bold leading-snug text-foreground-950 md:text-5xl md:leading-tight">
            女友的妈妈短剧合集：从见家长到婚后日常的剧情演绎
          </h1>

          <p className="mt-5 max-w-2xl text-sm leading-relaxed text-foreground-600 md:text-base">
            这里汇集女友的妈妈相关真人剧情短片，涵盖各种演绎风格和岳母题材小视频。无论你想看温馨日常还是冲突反转，
            都能在下面的合集里找到对应片段，满足你对这类剧情的全部好奇。
          </p>
        </div>

        {/* 入口条：首屏主导的快捷入口 */}
        <div className="mt-8 rounded-lg border border-background-200 bg-background-100/80 p-3 md:mt-10 md:p-4">
          <div className="mb-3 flex flex-wrap items-center justify-between gap-2">
            <span className="flex items-center gap-2 text-sm font-medium text-foreground-800">
              <span className="flex h-5 w-5 items-center justify-center text-primary-600">
                <i className="ri-apps-2-line text-base" aria-hidden="true" />
              </span>
              按题材快速进入合集
            </span>
            <span className="text-xs text-foreground-500">点击后自动筛选下方合集列表</span>
          </div>
          <div className="flex flex-wrap gap-2">
            {entryCats.map((cat) => (
              <a
                key={cat}
                href="#catalog"
                onClick={() => onPickCategory(cat)}
                className="group inline-flex cursor-pointer items-center gap-1.5 whitespace-nowrap rounded-md border border-background-300 bg-background-50 px-3 py-2 text-sm text-foreground-700 transition-colors hover:border-primary-300 hover:bg-primary-50 hover:text-primary-700"
              >
                <span className="flex h-4 w-4 items-center justify-center text-accent-600">
                  <i className="ri-bookmark-3-line text-sm" aria-hidden="true" />
                </span>
                {cat}
              </a>
            ))}
            <a
              href="#new"
              className="inline-flex cursor-pointer items-center gap-1.5 whitespace-nowrap rounded-md bg-foreground-950 px-3 py-2 text-sm font-medium text-background-50 transition-colors hover:bg-foreground-800"
            >
              <span className="flex h-4 w-4 items-center justify-center">
                <i className="ri-arrow-down-line text-sm" aria-hidden="true" />
              </span>
              查看最新更新
            </a>
          </div>
        </div>

        <dl className="mt-8 grid grid-cols-2 gap-3 md:mt-10 md:grid-cols-4 md:gap-4">
          {stats.map((s) => (
            <div key={s.id} className="rounded-lg border border-background-200 bg-background-50 px-4 py-3 md:px-5 md:py-4">
              <dt className="text-xs text-foreground-500">{s.label}</dt>
              <dd className="mt-1 font-heading text-2xl font-bold text-primary-600 md:text-3xl">{s.value}</dd>
            </div>
          ))}
        </dl>
      </div>
    </section>
  );
}